import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import organizationData from '../../data/db.json'; // Import your org data

const Footer = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-4 gap-8"
        >
          {/* Company Info */}
          <motion.div variants={itemVariants}>
            <Link to="/" className="text-2xl font-bold text-white mb-4 block">
              {organizationData.name}
            </Link>
            <p className="text-gray-300 mt-2">{organizationData.tagline}</p>
            <div className="flex mt-4 space-x-4">
              {organizationData.socials?.facebook && (
                <a href={organizationData.socials.facebook} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <i className="fab fa-facebook-f"></i>
                </a>
              )}
              {organizationData.socials?.instagram && (
                <a href={organizationData.socials.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <i className="fab fa-instagram"></i>
                </a>
              )}
              {organizationData.socials?.youtube && (
                <a href={organizationData.socials.youtube} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <i className="fab fa-youtube"></i>
                </a>
              )}
              {organizationData.socials?.telegram && (
                <a href={organizationData.socials.telegram} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                  <i className="fab fa-telegram"></i>
                </a>
              )}
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div variants={itemVariants}>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white">Home</Link></li>
              <li><Link to="/experts" className="text-gray-300 hover:text-white">Our Experts</Link></li>
              <li><Link to="/courses" className="text-gray-300 hover:text-white">Courses</Link></li>
              <li><Link to="/pricing" className="text-gray-300 hover:text-white">Pricing</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white">Contact Us</Link></li>
              <li><Link to="/app" className="text-gray-300 hover:text-white">Our App</Link></li>
            </ul>
          </motion.div>

          {/* Resources */}
          <motion.div variants={itemVariants}>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-gray-300 hover:text-white">Blog</Link></li>
              <li><Link to="/study-material" className="text-gray-300 hover:text-white">Study Material</Link></li>
              <li><Link to="/testimonials" className="text-gray-300 hover:text-white">Testimonials</Link></li>
              <li><Link to="/faqs" className="text-gray-300 hover:text-white">FAQs</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-white">Terms of Service</Link></li>
            </ul>
          </motion.div>

          {/* Contact Us */}
          <motion.div variants={itemVariants}>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <p className="text-gray-300 mb-2 flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.06-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-1C9.163 18 2 10.837 2 3V3z" />
              </svg>
              {organizationData.phone}
            </p>
            <p className="text-gray-300 mb-2 flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M2.01 6.6A2 2 0 014 5h16a2 2 0 011.99 1.6L12 13.293 2.01 6.6zM2 8.868v8.732A2.4 2.4 0 004.4 20h15.2a2.4 2.4 0 002.4-2.4V8.868l-9.19 6.178a1 1 0 01-1.22 0L2 8.868z" />
              </svg>
              {organizationData.email}
            </p>
            <p className="text-gray-300 flex items-start">
              <svg className="w-5 h-5 mr-2 mt-1" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 6.08 7 13 7 13s7-6.92 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
              </svg>
              {organizationData.address}
            </p>
          </motion.div>
        </motion.div>

        <div className="text-center mt-10 text-gray-500 text-sm">
          © {new Date().getFullYear()} {organizationData.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
